import styled from "styled-components";
import colors from "../config/colors";

const Button = styled.a`
  font-size: 1.1rem;
  display: inline-block;
  color: ${colors.text};
  border: 1px solid ${colors.text};
  background: ${({ type }) => {
    switch (type) {
      case "primary":
        return colors.yellow;
      default:
        return "transparent";
    }
  }};
  cursor: pointer;
  padding: 0 1rem;
  text-transform: uppercase;
  text-decoration: none;
  font-weight: 700;
  height: 3rem;
  line-height: 3rem;
  vertical-align: middle;
  letter-spacing: 0.05rem;
  background: linear-gradient(
    135deg,
    ${colors.yellow} 0%,
    ${colors.yellow} 50%,
    #d6c639 50%,
    #d6c639 70%,
    #535034 70%,
    #535034 100%
  );
  background-size: 400%;
  background-position: 30% 30%;
  transition: all 400ms cubic-bezier(0.35, 0.94, 0.62, 0.99);

  &:hover {
    color: ${colors.white};
    background-position: 99% 99%;
  }
`;

export default Button;



// WEBPACK FOOTER //
// ./src/components/Button.js